import React, {useContext} from 'react'
import {AltaContext} from '../AltaContext'
import {ExportFieldBody} from './ExportFieldBody'
import {ExportFieldHeader} from './ExportFieldHeader'

const ExportFiledModal: React.FC = () => {
  const {isOpenFieldModal} = useContext(AltaContext)

  return (
    <>
      {isOpenFieldModal ? (
        <>
          <div>
            <div className='modal fade show d-block' role='dialog' tabIndex={-1} aria-modal='true'>
              {/* begin::Modal dialog */}
              <div className='modal-dialog modal-dialog-centered modal-md'>
                {/* begin::Modal content */}
                <div className='modal-content'>
                  <ExportFieldHeader />
                  {/* begin::Modal body */}
                  <div className='modal-body scroll-y mx-5 mx-xl-5 my-2'>
                    <ExportFieldBody />
                  </div>
                  {/* end::Modal body */}
                </div>
                {/* end::Modal content */}
              </div>
              {/* end::Modal dialog */}
            </div>
          </div>
          {/* begin::Modal Backdrop */}
          <div className='modal-backdrop fade show'></div>
          {/* end::Modal Backdrop */}
        </>
      ) : null}
    </>
  )
}

export {ExportFiledModal}
